/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { Box, Button, Link, Stack } from "@mui/material";
import useAuth from "../hooks/use-auth";
import { useParams } from "react-router-dom";

const CustomFooter = ({ name, isShowProfile = false }) => {
  // #region css
  const footer = css({
    // position:'fixed',
    // left: 0,
    // bottom: 0,
    position: "relative",
    // width: "100%",
    height: "33px",
    backgroundColor: "#009043",
    padding: "20px 25px",
    marginTop: "auto",
  });
  const profileHolder = css({
    borderRadius: 50,
    padding: "0px 7px",
    background: "white",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    color: "#2b2b2b",
    fontSize: 14,
    boxShadow: "3px 3px 5px rgba(0, 0, 0, 0.2)",
  });
  const nameLabel = css({
    letterSpacing: "2.75px",
  });
  const logoutBtn = css({
    color: "#2b2b2b",
    opacity: 0.4,
    fontWeight: 600,
    minWidth: 48,
  });
  const fakeDivider = css({
    color: "#009043",
    marginLeft: 8,
  });
  const privacyLink = css({
    position: "absolute",
    right: 20,
    top: 20,
  });
  const divider = css({
    color: "white",
  });
  // #endregion

  const { signOut } = useAuth();
  const { eDepartmentId } = useParams();

  const hideName = () => {
    if (name === "親愛的用戶") return name;
    const replaceChar = "●";
    const replaceLength = name.length - 2;
    return name.length === 2
      ? name.slice(0, 1) + replaceChar
      : name.length > 2
      ? name.slice(0, 1) +
        replaceChar.repeat(replaceLength) +
        name.slice(name.length - 1)
      : name;
  };

  return (
    <Box css={footer}>
      {isShowProfile && (
        <Box css={profileHolder}>
          <label css={nameLabel}>{hideName()}</label>
          <label>您好 </label>
          <label css={fakeDivider}>|</label>
          {/* <Divider orientation="vertical" variant="middle" flexItem /> */}
          <Button variant="text" css={logoutBtn} onClick={signOut}>
            登出
          </Button>{" "}
        </Box>
      )}
      <Stack css={privacyLink} direction="row" spacing={1}>
        <Link href={ eDepartmentId ? `/${eDepartmentId}/privacy` : '/' } target={eDepartmentId ? "_blank" : "_self"} color="#fff">
          隱私權政策
        </Link>{" "}
        <Box css={divider}>|</Box>
        <Link href={ eDepartmentId ? `/${eDepartmentId}/term` : '/' } target={eDepartmentId ? "_blank" : "_self"} color="#fff">
          網站使用條款
        </Link>
      </Stack>
    </Box>
  );
};

export default CustomFooter;
